import React from "react";
import PropTypes from "prop-types";
import ClinicalEvidencesTableHeaders from "./ClinicalEvidencesTableHeaders";
import ClinicalEvidencesTableRows from "./ClinicalEvidencesTableRows";
import { sortedResults } from "./helpers";

const ClinicalEvidencesTable = ({ result, isGene }) => {
  if (result) {
    return (
      <div className="varsome-inner-container">
        <h5>Clinical Evidence</h5>
        <table className="varsome-table">
          <ClinicalEvidencesTableHeaders isGene={isGene} />
          <ClinicalEvidencesTableRows
            result={sortedResults(result)}
            isGene={isGene}
          />
        </table>
      </div>
    );
  }

  return null;
};

ClinicalEvidencesTable.propTypes = {
  isGene: PropTypes.bool,
  result: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

ClinicalEvidencesTable.defaultProps = {
  isGene: false,
  result: null,
};
export default ClinicalEvidencesTable;
